<template>
  <section
    :class="[
      'burger',
      !utils.isTouchDevice() ? 'apollo__magnetism' : false,
      active ? 'burger--active' : false,
      anim ? 'burger--trans' : false,
      $route.name === 'error404' ? 'burger--hidden' : false,
    ]"
    @click="toggleMenu"
    data-anim="fade"
  >
    <div class="line"><bdi /></div>
    <div class="line"><bdi /></div>
    <div class="line"><bdi /></div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import utils from '@/scripts/utils';

export default {
  name: 'Burger',

  data() {
    return {
      active: false,
      anim: false,
      utils,
    };
  },

  computed: {
    ...mapGetters({
      menu: 'getMenu',
      menuTrans: 'getMenuTrans',
    }),
  },

  watch: {
    menu(n) {
      this.active = n;
    },
    menuTrans(n) {
      this.anim = n;
    },
  },

  methods: {
    toggleMenu() {
      if (this.anim) return;

      this.$store.commit('TOGGLE_MENU');
    },
  },
};
</script>

<style lang="scss" scoped>
.burger {
  position: relative;
  width: rem(35px);
  padding: rem(30px) 0;
  grid-area: b;
  margin: 0 0 0 auto;

  @include mq(ipadP) {
    grid-area: a;
    width: rem(60px);
    margin: 0;
  }

  cursor: pointer;
  pointer-events: auto;

  .line {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    backface-visibility: hidden;

    &:nth-child(1) {
      transform: translate3d(0, -7px, 0);
      @include mq(ipadP) {
        transform: translate3d(0, -10px, 0);
      }

      bdi {
        transform: scaleX(0.4) translateZ(0px);
        transform-origin: 100% 50%;
        backface-visibility: hidden;
      }
    }

    &:nth-child(2) {
      transform: translate3d(0, 0, 0);
    }

    &:nth-child(3) {
      transform: translate3d(0, 7px, 0);
      @include mq(ipadP) {
        transform: translate3d(0, 10px, 0);
      }

      bdi {
        transform: scaleX(0.4) translateZ(0px);
        transform-origin: 0% 50%;
      }
    }

    bdi {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background-color: $color-dark-light;
      transition: all 0.8s $outExpo;
    }
  }

  &:hover {
    @include mq($and: $is-hover) {
      .line {
        &:nth-child(1),
        &:nth-child(3) {
          bdi {
            transform: scaleX(1) translateZ(0px);
          }
        }
      }
    }
  }

  &--trans {
    pointer-events: none;
  }

  &--hidden {
    opacity: 0 !important;
  }

  &--active {
    .line {
      &:nth-child(1),
      &:nth-child(3) {
        bdi {
          transform: scaleX(0) translateZ(0px);
        }
      }
    }

    // &:hover {
    //   .line {
    //     &:nth-child(1),
    //     &:nth-child(3) {
    //       bdi {
    //         transform: scaleX(0.38) translateZ(0px);
    //       }
    //     }
    //   }
    // }
  }
}
</style>
